import * as XLSX from 'xlsx';



export function downloadXLSX(resultsData, columns, filename) {
	let headersArray = ['Sentence'] // Sentence is default value, we fill that in any case
	let dataArray = []
	columns.map((item) => {
		if (item.active === true) {
			headersArray.push(item.name)
		}
	})
	headersArray.splice(1, 0, 'doi')
	// dataArray.push(headersArray)



	let arrIndex = 0
	resultsData.forEach((item) => {

		let rowObject = {}
		const row = headersArray.map((header) => {
			if (header in item.data) {
				//если у нас доп колонка (в которой объект у меня всегда), то тогда берем данные с объекта

				if (typeof item.data[header] == 'object') {
					if (item.data[header].result) {
						if(header === 'Emails'){
							let emails = ''
							item.data[header].result.forEach((item) => {
								emails += `${item}\n`
							})
							rowObject[header] = emails
						}
						else if(header === 'Institutions'){
							let institutions = ''
							const instArray = item.data[header].result.split('\n').filter(item => item.trim() !== '')
							instArray.forEach((item) => {
								institutions += `${item}\n`
							})
							rowObject[header] = institutions

						}
						else if(header === 'Regions'){
							let regions = ''
							item.data[header].result.forEach((item) => {
								regions += `${item}\n`
							})
							return regions
						}
						else if(header === 'Countries'){
							let countries = ''
							item.data[header].result.forEach((item) => {
								countries += `${item}\n`
							})
							return countries
						}
						else{
							rowObject[header] = item.data[header].result


						}

					} else {
						rowObject[header] = ''

					}
				}
				//если простая дефолтная колонка
				else {
					rowObject[header] = item.data[header]

				}
			}
			if(header === 'doi'){
				rowObject[header] = 'https://doi.org/'+item.doi

			}

		})

		dataArray.push(rowObject)
		//dataArray.push(row)

	})

	/* generate worksheet and workbook */
	const worksheet = XLSX.utils.json_to_sheet(dataArray);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, "Dates");

	/* fix headers */
	XLSX.utils.sheet_add_aoa(worksheet, [headersArray], { origin: "A1" });

	/* calculate column width */
	worksheet["!cols"] = [ { wch: 55 } ];

	/* create an XLSX file and try to save to Presidents.xlsx */
	XLSX.writeFile(workbook, filename+".xlsx", { compression: true });





}



